import { gql } from "@apollo/client";

// getCashInHandReport is a Query (not a mutation) in admin.graphql - it
// aggregates settlement ledger entries (from settlePayments / verifyBooking)
// grouped by employee for a given date range.
export const GET_CASH_IN_HAND_REPORT = gql`
  query GetCashInHandReport($data: CashInHandReportInput) {
    getCashInHandReport(data: $data) {
      status
      message
      totalCash
      totalOnline
      rows {
        employeeId
        employeeName
        cashAmount
        onlineAmount
      }
    }
  }
`;
